import { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { gtm } from 'apps/gtm';

import { changeBasketQuantity } from 'apps/basket/actions/basket';
import { FopContainerBasketItems, FopContainerViewPreferenceShape, FopContainerVisibleFops } from '../types';

import { dynamicYieldService } from 'apps/dynamicYield';

import Locations from 'apps/basket/models/Locations';

export default class AbstractFopContainer extends Component {
  static propTypes = {
    afterBasketQuantityChange: PropTypes.func,
    basketItems: FopContainerBasketItems,
    betaFeatures: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    fopCollection: PropTypes.object.isRequired,
    fopViewPreference: FopContainerViewPreferenceShape,
    gtmPageType: PropTypes.string,
    productsBySku: PropTypes.object.isRequired,
    productWarnings: PropTypes.objectOf(PropTypes.array),
    quickMenuExpanded: PropTypes.object,
    shoppingListsModal: PropTypes.bool,
    skipAnalytics: PropTypes.bool,
    subscriptionsBySku: PropTypes.object,
    visibleFops: FopContainerVisibleFops,
  };

  static triggerTrolleyEvent({ gtmPageType, analyticsDataSubset, product, quantityDiff, basket }) {
    const productData = {
      gtmPageType,
      cartActionType: 'FOP',
      product,
      quantity: Math.abs(quantityDiff),
      section: analyticsDataSubset.section,
      containerType: analyticsDataSubset.containerType,
      collectionFopIdx: analyticsDataSubset.collectionFopIdx,
      basket,
    };

    dynamicYieldService.reportCartEvent({
      quantityDelta: quantityDiff, ...analyticsDataSubset,
    });
    dynamicYieldService.reportSyncCartEvent({ basketItems: get(basket, 'items', []) });
    gtm.trigger(quantityDiff > 0 ? 'gtm:addToTrolley' : 'gtm:removeFromTrolley', productData);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.fopCollection !== nextProps.fopCollection
      || this.props.basketItems !== nextProps.basketItems
      || this.props.fopViewPreference !== nextProps.fopViewPreference
      || this.props.productsBySku !== nextProps.productsBySku
      || this.props.productWarnings !== nextProps.productWarnings
      || this.props.quickMenuExpanded !== nextProps.quickMenuExpanded
      || this.props.shoppingListsModal !== nextProps.shoppingListsModal
      || this.props.subscriptionsBySku !== nextProps.subscriptionsBySku
      || this.props.visibleFops !== nextProps.visibleFops;
  }

  onQuantitySubmit = (sku, quantityDiff, analyticsDataSubset) => {
    const {
      dispatch,
      afterBasketQuantityChange,
      gtmPageType,
      productsBySku,
      basket,
    } = this.props;
    dispatch(changeBasketQuantity({
      items: { [sku]: quantityDiff },
      location: Locations.FOPLIST,
      analyticsContextData: analyticsDataSubset,
    }))
      .then(() => {
        if (afterBasketQuantityChange) {
          afterBasketQuantityChange(quantityDiff);
        }
      });
    AbstractFopContainer.triggerTrolleyEvent(
      { gtmPageType, analyticsDataSubset, product: productsBySku[sku], quantityDiff, basket }
    );
  };
}
